module.exports = __webpack_public_path__ + "img/icon-menu-notification.5ead352e.svg";